import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    sortBy: string;
    orderBy: string;
    filterBy: string;
    sortByOrderLabel: {
        LAST_VIEWED_AT: {
            /** Label for last viewed sort field */
            label: string;
            /** Ascending label for last viewed sort */
            ASC: string;
            /** Descending label for last viewed sort */
            DESC: string;
        };
        VIEW_COUNT: {
            /** Label for view count sort field */
            label: string;
            /** Ascending label for view count sort */
            ASC: string;
            /** Descending label for view count sort */
            DESC: string;
        };
        INSERTED_AT: {
            /** Label for created date sort field */
            label: string;
            /** Ascending label for created date sort */
            ASC: string;
            /** Descending label for created date sort */
            DESC: string;
        };
        UPDATED_AT: {
            /** Label for updated date sort field */
            label: string;
            /** Ascending label for updated date sort */
            ASC: string;
            /** Descending label for updated date sort */
            DESC: string;
        };
        NAME: {
            /** Label for name sort field */
            label: string;
            /** Ascending label for name sort */
            ASC: string;
            /** Descending label for name sort */
            DESC: string;
        };
    };
    filterByLabel: {
        /** Filter label for all shares */
        ALL: string;
        /** Filter label for shares created by the user */
        CREATED_BY_USER: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu group label for sorting shares */
            sortBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortBy?c=23o1l1s3scgd9", defaultMessage: "Sort By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the sort order toggle */
            orderBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.orderBy?c=ij082fuh5azd", defaultMessage: "Order By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group label for filtering shares */
            filterBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.filterBy?c=28umyt3td90t3", defaultMessage: "Filter By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Labels for sort-by fields and order values */
            sortByOrderLabel: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        LAST_VIEWED_AT: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Label for last viewed sort field */
                                    label: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.LAST_VIEWED_AT.label?c=okm4etg1za9h", defaultMessage: "Latest Activity" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Ascending label for last viewed sort */
                                    ASC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.LAST_VIEWED_AT.ASC?c=1jqr3zsnmsj76", defaultMessage: "Oldest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Descending label for last viewed sort */
                                    DESC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.LAST_VIEWED_AT.DESC?c=2o2mgiuy9yv9g", defaultMessage: "Latest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        VIEW_COUNT: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Label for view count sort field */
                                    label: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.VIEW_COUNT.label?c=x32bno39x62p", defaultMessage: "View Count" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Ascending label for view count sort */
                                    ASC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.VIEW_COUNT.ASC?c=2wn3r582ys50s", defaultMessage: "Least" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Descending label for view count sort */
                                    DESC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.VIEW_COUNT.DESC?c=3gszsrnreh7e5", defaultMessage: "Most" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        INSERTED_AT: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Label for created date sort field */
                                    label: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.INSERTED_AT.label?c=2kb8fcug33grf", defaultMessage: "Date Created" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Ascending label for created date sort */
                                    ASC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.INSERTED_AT.ASC?c=1jqr3zsnmsj76", defaultMessage: "Oldest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Descending label for created date sort */
                                    DESC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.INSERTED_AT.DESC?c=2ykss5j1ih39c", defaultMessage: "Newest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        UPDATED_AT: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Label for updated date sort field */
                                    label: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.UPDATED_AT.label?c=grfvxntgl36a", defaultMessage: "Date Updated" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Ascending label for updated date sort */
                                    ASC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.UPDATED_AT.ASC?c=1jqr3zsnmsj76", defaultMessage: "Oldest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Descending label for updated date sort */
                                    DESC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.UPDATED_AT.DESC?c=2ykss5j1ih39c", defaultMessage: "Newest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        NAME: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Label for name sort field */
                                    label: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.NAME.label?c=2qzusb663t513", defaultMessage: "Alphabetical" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Ascending label for name sort */
                                    ASC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.NAME.ASC?c=30tt2bnp9rp9w", defaultMessage: "A \u2192 Z" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Descending label for name sort */
                                    DESC: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.sortByOrderLabel.NAME.DESC?c=1046b4wsp7kk", defaultMessage: "Z \u2192 A" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Labels for filter-by options */
            filterByLabel: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Filter label for all shares */
                        ALL: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.filterByLabel.ALL?c=2pjvzdn4ijquz", defaultMessage: "All Shares" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Filter label for shares created by the user */
                        CREATED_BY_USER: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesMenuContent.filterByLabel.CREATED_BY_USER?c=1ox2ipkohympi", defaultMessage: "Created by You" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
